var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUser, LoyaltyApi, ReferralApi } from "@jti/rest-api";
import { isLoyaltyRestricted } from "../../utils/isLoyaltyRestricted";
import { setLoadedState, setLoggedState, setReferralStatus, setRestrictedState } from "../loyaltyCore";
import { handleUser } from "./handleUser";
export function isValidUser(user) {
    return !!(user.uuid && user.ciam_token);
}
export const fetchStatus = createAsyncThunk("loyaltyCore/fetchStatus", () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const [loyaltyStatus, referralStatus] = yield Promise.all([
            LoyaltyApi.init().getStatus(),
            ReferralApi.init().getStatus(),
        ]);
        return { loyaltyStatus, referralStatus };
    }
    catch (error) {
        console.error(error);
        return { loyaltyStatus: false, referralStatus: false };
    }
}));
export const pageRun = createAsyncThunk("loyaltyCore/pageRun", ({ name, isRestricted, isInEditor }, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    const { loyaltyStatus, referralStatus } = yield dispatch(fetchStatus()).unwrap();
    const isReferralPage = name === "referral";
    const isLoyaltyOff = !isReferralPage && !loyaltyStatus;
    const isReferralOff = isReferralPage && !referralStatus;
    const isRasAndLoyaltyOn = isReferralPage && referralStatus && loyaltyStatus;
    const checkReferralAndLoyaltyStatus = (isLoyaltyOff || isReferralOff || isRasAndLoyaltyOn) && !isInEditor;
    if (checkReferralAndLoyaltyStatus) {
        if (typeof window === "object" && window !== undefined) {
            window.location.replace("/");
            throw new Error("Loyalty or Referral is not active");
        }
    }
    dispatch(setReferralStatus(referralStatus));
    if (isRestricted) {
        try {
            const restricted = yield isLoyaltyRestricted();
            dispatch(setRestrictedState(restricted));
        }
        catch (error) {
            console.error("Error checking if loyalty is restricted", error);
        }
    }
    dispatch(setLoadedState(true));
    const user = getUser();
    if (isValidUser(user)) {
        try {
            dispatch(setLoggedState(true));
            yield dispatch(handleUser({ user, isLoyaltyActive: loyaltyStatus, isReferralActive: referralStatus }));
        }
        catch (error) {
            console.error("User validation failed", error);
        }
    }
}));
//# sourceMappingURL=pageRun.js.map